<div class="search-section">
  <div class="container">
    <form action="#" method="post" novalidate="novalidate">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-5 col-md-5 col-sm-12 p-0">
              <input type="text" class="form-control search-slot" id="search-text" placeholder="What are you looking for?" name="query" [(ngModel)]="search_query" />
            </div>
            <div *ngIf="on_bonnie" class="col-lg-4 col-md-4 col-sm-12 p-0">
              <div class="input-group input-group-seamless">
                <span class="input-group-prepend" *ngIf="locationPermissionGiven === true">
                  <span class="input-group-text" #location (click)="getLocation(location)">
                    <i class="fa fa-map-marker-alt"></i>
                  </span>
                </span>
                <input type="text" class="form-control search-slot" id="search-location" placeholder="Location" name="location" (input)="log('input')" [(ngModel)]="search_location" [ngbTypeahead]="search2" (focus)="focus$.next($event.target.value); log('element focused');" (click)="click$.next($event.target.value); log('element clicked');" #instance="ngbTypeahead" />
                <small *ngIf="searching" class="form-text text-muted">searching...</small>
                <div class="invalid-feedback" *ngIf="searchFailed">Sorry, suggestions could not be loaded.</div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 p-0">
              <button [routerLink]="'/search/' + search_query + '/' + search_location" type="button" class="btn btn-secondary search-button">
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>